
const resources = {
	fieldIsRequired: "این فیلد الزامی است!",
	invalidFormat: "فرمت وارد شده صحیح نیست!",

	numberTooSmall: "عدد وارد شده حداقل باید {0} باشد.",
	numberTooBig: "عدد وارد شده حداکثر باید {0} باشد.",
	invalidNumber: "عدد نامعتبر",
	invalidInteger: "مقدار وارد شده عدد صحیح نیست",

	textTooSmall: "طول فیلد وارد شده حداقل باید {1} کاراکتر باشد؛ مقدار جاری {0} حرف است.",
	textTooBig: "طول فیلد وارد شده حداکثر باید {1} کاراکتر باشد؛ مقدار جاری {0} حرف است.",
	thisNotText: "لطفا یک مقدار رشته ای برای این فیلد وارد کنید",

	thisNotArray: "This is not an array!",

	selectMinItems: "Select minimum {0} items!",
	selectMaxItems: "Select maximum {0} items!",

	invalidDate: "Invalid date!",
	dateIsEarly: "The date is too early! Current: {0}, Minimum: {1}",
	dateIsLate: "The date is too late! Current: {0}, Maximum: {1}",

	invalidEmail: "آدرس ایمیل وارد شده معتبر نیست",
	invalidURL: "آدرس URL وارد شده معتبر نیست",

	invalidCard: "Invalid card format!",
	invalidCardNumber: "Invalid card number!",

	invalidTextContainNumber: "لطفا فقط از حروف الفبا استفاده کنید.",
	invalidTextContainSpec: "لطفا از کارکترهای خاص استفاده نکنید"
};

export default resources